import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionsService } from './permissions.service';
import { LoginService } from './login.service';

// Non-sensitive client-side flag indicating the user completed login. The real auth credential
// is the httpOnly cookie (unreadable by JS); this flag only drives client-side routing/UX.
const AUTH_FLAG = 'isAuthenticated';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private permissionsService: PermissionsService,
    private loginService: LoginService
  ) { }

  isAuthenticated(): boolean {
    return localStorage.getItem(AUTH_FLAG) === 'true';
  }

  setAuthenticated(): void {
    localStorage.setItem(AUTH_FLAG, 'true');
  }

  userType() {
    const value = localStorage.getItem('isSuperAdmin');
    return value === 'true';
  }

  userRole() {
    const value = localStorage.getItem('role');
    return value === 'manager' || value === 'salesManager';
  }

  private clearClientState() {
    localStorage.removeItem(AUTH_FLAG);
    localStorage.removeItem('token'); // legacy key from the old localStorage-token scheme
    localStorage.removeItem('isSuperAdmin');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    localStorage.removeItem('walletAmount');
    // Clear permissions
    this.permissionsService.clearPermissions();
  }

  logout() {
    // Revoke the refresh token + clear cookies server-side, then clear local state regardless of outcome.
    this.loginService.logout().subscribe({
      next: () => this.finishLogout(),
      error: () => this.finishLogout()
    });
  }

  private finishLogout() {
    this.clearClientState();
    this.router.navigate(['/login']);
  }
}
